// import { lazy } from "react"
import loadable from '@loadable/component'

const Header = loadable(() => import("./Header/Header"))
const ExtraHeader = loadable(() => import("./Header/ExtraHeader"))
const TalkToExpert = loadable(() => import("./Header/TalkToExpert/TalkToExpert"))
const LeadSection = loadable(() => import("./LeadSection/LeadSection"))
const Description = loadable(() => import("./Description/Description"))
const CardSection = loadable(() => import("./CardSection/CardSection"))
const WhyInvest = loadable(() => import("./WhyInvest/WhyInvest"))
const WhatIs = loadable(() => import("./WhatIs/WhatIs"))
const SavingPlans = loadable(() => import("./SavingPlans/SavingPlans"))
const Disclaimers = loadable(() => import("./Disclaimers/Disclaimers"))

export { Header, ExtraHeader, TalkToExpert, LeadSection, CardSection, Description, WhyInvest, WhatIs, SavingPlans, Disclaimers }
